exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__1rfbU{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2pCpd{display:none!important}}@media (max-width:79.9rem){.style_hide-md__3xdAx{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1SgQn{display:none!important}}.style_titleBar__3251A{background-color:#fff;height:3rem;display:flex;justify-content:space-between;align-items:center;padding:0 1rem}.style_title__Yghwr{flex-grow:1;font-size:1.25rem}.style_title__Yghwr h1,.style_title__Yghwr h2{font-size:1.25rem;margin:0;padding:0}.style_pageTitleLink__10IIo{color:#333;text-decoration:none}.style_pageTitleLink__10IIo>:active,.style_pageTitleLink__10IIo>:visited{color:#333}.style_pageTitleLink__10IIo:hover{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__1rfbU",
	"hideSm": "style_hide-sm__1rfbU",
	"visible-sm": "style_visible-sm__2pCpd",
	"visibleSm": "style_visible-sm__2pCpd",
	"hide-md": "style_hide-md__3xdAx",
	"hideMd": "style_hide-md__3xdAx",
	"visible-md": "style_visible-md__1SgQn",
	"visibleMd": "style_visible-md__1SgQn",
	"titleBar": "style_titleBar__3251A",
	"title": "style_title__Yghwr",
	"pageTitleLink": "style_pageTitleLink__10IIo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/AreaTitle/style.less
// module id = 1577
// module chunks = 8